'use client';

import { type LayoutNode, type LayoutNodeStyleMap } from 'shop-ui/types';
import { ELEMENT_TYPE, FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import i18n from '@shared/i18n';

export const componentName = 'ProductPromoInfo';

export enum OFFICIAL_PRODUCT_PROMO_INFO_KEY {
    PAGE_PRODUCT_PROMO_INFO = 'official-page-product-promo-info',
}

export const showCutList = [
    {
        key: OFFICIAL_PRODUCT_PROMO_INFO_KEY.PAGE_PRODUCT_PROMO_INFO,
        type: ELEMENT_TYPE.PRODUCT_PROMO_INFO,
        content: i18n.gettext('優惠資訊'),
        version: 1,
    },
];

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.PRODUCT_PROMO_INFO,
    name: componentName,
    enable: true, // 通常要開啟
    next: null,
    deletable: false, // 通常要開啟
};

export const features = [
    FEATURE_FLAG_KEYS.ENABLE_CONTENT,
    FEATURE_FLAG_KEYS.RESIZE_HANDLE,
    FEATURE_FLAG_KEYS.RICH_TEXT,
    FEATURE_FLAG_KEYS.FONT_FAMILY,
    FEATURE_FLAG_KEYS.FONT_WEIGHT,
    FEATURE_FLAG_KEYS.FONT_SIZE_CUSTOM,
    FEATURE_FLAG_KEYS.FONT_COLOR,
    FEATURE_FLAG_KEYS.FONT_STYLE,
    // FEATURE_FLAG_KEYS.TEXT_ALIGNMENT,
    FEATURE_FLAG_KEYS.TEXT_LETTER_SPACING,
    FEATURE_FLAG_KEYS.COMPONENT_PROMO_BADGE_BG_COLOR,
    FEATURE_FLAG_KEYS.COMPONENT_PROMO_BADGE_TEXT_COLOR,
    FEATURE_FLAG_KEYS.COMPONENT_GIVEAWAY_BADGE_BG_COLOR,
    FEATURE_FLAG_KEYS.COMPONENT_GIVEAWAY_BADGE_TEXT_COLOR,
    FEATURE_FLAG_KEYS.COMPONENT_SHIPPING_BADGE_BG_COLOR,
    FEATURE_FLAG_KEYS.COMPONENT_SHIPPING_BADGE_TEXT_COLOR,
    FEATURE_FLAG_KEYS.ANIMATION,
];

const defaultStyle = {
    [FEATURE_FLAG_KEYS.ENABLE_CONTENT]: true,
    [FEATURE_FLAG_KEYS.FONT_FAMILY]: 'Inter',
    [FEATURE_FLAG_KEYS.FONT_WEIGHT]: '400',
    [FEATURE_FLAG_KEYS.FONT_SIZE]: 'custom',
    [FEATURE_FLAG_KEYS.FONT_SIZE_CUSTOM]: '16',
    [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(57, 57, 62, 1)',
    // [FEATURE_FLAG_KEYS.TEXT_ALIGNMENT]: 'left',
    [FEATURE_FLAG_KEYS.TEXT_LETTER_SPACING]: '0px',
    [FEATURE_FLAG_KEYS.COMPONENT_PROMO_BADGE_BG_COLOR]: 'rgba(255, 248, 246, 1)',
    [FEATURE_FLAG_KEYS.COMPONENT_PROMO_BADGE_TEXT_COLOR]: 'rgba(234, 124, 111, 1)',
    [FEATURE_FLAG_KEYS.COMPONENT_GIVEAWAY_BADGE_BG_COLOR]: 'rgba(255, 248, 246, 1)',
    [FEATURE_FLAG_KEYS.COMPONENT_GIVEAWAY_BADGE_TEXT_COLOR]: 'rgba(234, 124, 111, 1)',
    [FEATURE_FLAG_KEYS.COMPONENT_SHIPPING_BADGE_BG_COLOR]: 'rgba(239, 246, 252, 1)',
    [FEATURE_FLAG_KEYS.COMPONENT_SHIPPING_BADGE_TEXT_COLOR]: 'rgba(124, 186, 210, 1)',
} as const;

export function createProductPromoInfo(presetStyle?: LayoutNodeStyleMap[string]) {
    const id = getElementUlId();

    const layout = {
        ...config,
        id,
    };

    return {
        id,
        layout,
        style: {
            ...defaultStyle,
            ...presetStyle,
        },
        content: i18n.gettext('此商品適用的優惠活動'),
    };
}

export function generate(
    sectionName: string = i18n.gettext('區塊'),
    options?: { shouldWrap?: boolean }
) {
    const productPromoInfo = createProductPromoInfo();

    const shouldWrap = options?.shouldWrap ?? true;

    return combineComponent(sectionName, [productPromoInfo], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        shouldWrap,
    });
}
